'use client';
import React from 'react';
import { SHAME_ENTRIES } from './ShameData';

export default function ShameSpotlight() {
  const featured = SHAME_ENTRIES?.[0] ?? null;

  if (!featured) {
    return (
      <div
        className="relative rounded-2xl overflow-hidden mb-8 p-6 sm:p-8"
        style={{
          background: 'linear-gradient(135deg, rgba(25,5,5,0.99) 0%, rgba(35,10,5,0.98) 60%, rgba(20,8,3,0.99) 100%)',
          border: '1px dashed rgba(239,68,68,0.2)',
        }}
      >
        <div className="flex flex-col items-center justify-center py-8 gap-3 text-center">
          <span className="text-4xl">🔦</span>
          <div>
            <span className="text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full block mb-2"
              style={{ background: 'rgba(239,68,68,0.08)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.15)', display: 'inline-block' }}>
              🔦 Shame Spotlight
            </span>
            <h2 className="text-xl font-extrabold mb-1" style={{ color: 'rgba(255,255,255,0.8)' }}>No spotlight yet</h2>
            <p className="text-sm" style={{ color: 'rgba(255,255,255,0.35)' }}>
              The shame spotlight is empty. Add entries below to feature the top offender.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="relative rounded-2xl overflow-hidden mb-8 p-6 sm:p-8"
      style={{
        background: 'linear-gradient(135deg, rgba(25,5,5,0.99) 0%, rgba(35,10,5,0.98) 60%, rgba(20,8,3,0.99) 100%)',
        border: '1px solid rgba(239,68,68,0.25)',
        boxShadow: '0 0 80px rgba(239,68,68,0.07)',
      }}
    >
      <div className="absolute -top-10 -right-10 w-72 h-72 rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(249,115,22,0.1) 0%, transparent 70%)', filter: 'blur(50px)' }} />
      <div className="relative z-10 flex flex-col sm:flex-row items-start sm:items-center gap-6">
        <div
          className="w-20 h-20 rounded-2xl flex items-center justify-center text-4xl flex-shrink-0"
          style={{
            background: 'linear-gradient(135deg, rgba(239,68,68,0.15), rgba(249,115,22,0.1))',
            border: '1px solid rgba(239,68,68,0.25)',
            boxShadow: '0 0 30px rgba(239,68,68,0.15)',
          }}
        >
          {featured?.categoryIcon}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full"
              style={{ background: 'rgba(239,68,68,0.12)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.25)' }}>
              🔦 Shame Spotlight
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl font-extrabold mb-1" style={{ color: 'rgba(255,255,255,0.95)' }}>{featured?.category}</h2>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold"
              style={{ background: `${featured?.avatarColor}22`, color: featured?.avatarColor }}>
              {featured?.initials}
            </div>
            <span className="text-sm font-semibold" style={{ color: 'rgba(255,255,255,0.7)' }}>{featured?.displayName}</span>
            <span className="text-xs" style={{ color: 'rgba(255,255,255,0.3)' }}>{featured?.username}</span>
          </div>
          <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.5)' }}>{featured?.description}</p>
        </div>
        <div className="flex-shrink-0 text-center sm:text-right">
          <div className="text-5xl font-extrabold leading-none mb-1"
            style={{ background: 'linear-gradient(135deg, #ef4444, #f97316)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
            {featured?.stat}
          </div>
          <div className="text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>{featured?.statLabel}</div>
          <div className="mt-3 text-xs font-semibold px-3 py-1.5 rounded-full inline-block"
            style={{ background: 'rgba(239,68,68,0.1)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.2)' }}>
            🏷️ {featured?.badge}
          </div>
        </div>
      </div>
    </div>
  );
}
